export const DRAWFLOW_VIEWPORT_VERSION = 1;
export const DRAWFLOW_FIT_PADDING = 48;

const toFiniteNumber = value => {
  const number = Number(value);

  return Number.isFinite(number) ? number : null;
};

export const clampZoom = (zoom, minZoom, maxZoom) => {
  const value = toFiniteNumber(zoom);
  const minimum = toFiniteNumber(minZoom) ?? 0.5;
  const maximum = toFiniteNumber(maxZoom) ?? 1.6;

  return Math.min(maximum, Math.max(minimum, value ?? 1));
};

export const normalizeViewport = (viewport, minZoom, maxZoom) => {
  if (!viewport || typeof viewport !== "object") return null;

  const x = toFiniteNumber(viewport.x);
  const y = toFiniteNumber(viewport.y);
  const zoom = toFiniteNumber(viewport.zoom);
  if (x === null || y === null || zoom === null) return null;

  return {
    zoom: clampZoom(zoom, minZoom, maxZoom),
    x,
    y,
  };
};

export const createEditorMetadata = viewport => ({
  version: DRAWFLOW_VIEWPORT_VERSION,
  viewport: {
    zoom: viewport.zoom,
    x: viewport.x,
    y: viewport.y,
  },
});
